import request from 'sb-request'


const fetch = (params) =>
  request.get('rest/cart', params)

const fetchTotalPrice = () =>
  request.get('rest/cart/totalprice')

const postCart = (params) =>
  request.post('rest/cart', params)


export default {
  fetch,
  fetchTotalPrice,
  postCart,
}
